module.exports = __webpack_public_path__ + "img/hot.fc9f69c0.png";